/**
 * Date-extensions locale Hebrew [he]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('he', {
    monthNames: ['ינואר','פברואר','מרץ','אפריל','מאי','יוני','יולי','אוגוסט','ספטמבר','אוקטובר','נובמבר','דצמבר'],
    monthShortNames: ['ינו׳','פבר׳','מרץ','אפר׳','מאי','יוני','יולי','אוג׳','ספט׳','אוק׳','נוב׳','דצמ׳'],
    dayNames: ['ראשון','שני','שלישי','רביעי','חמישי','שישי','שבת'],
    dayShortNames: ['א׳','ב׳','ג׳','ד׳','ה׳','ו׳','ש׳']
});
